var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Site Settings")]),_c('h2',[_vm._v("Pages here. Sorta feeling like the old days.")])])}]

export { render, staticRenderFns }